import { render } from "./agregarProducto.vue?vue&type=template&id=12e71a38&scoped=true"
import script from "./agregarProducto.vue?vue&type=script&lang=js"
export * from "./agregarProducto.vue?vue&type=script&lang=js"

import "./agregarProducto.vue?vue&type=style&index=0&id=12e71a38&scoped=true&lang=css"
import "./agregarProducto.vue?vue&type=style&index=1&id=12e71a38&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e71a38"]])

export default __exports__